import React from 'react';

import { CustomDrawer } from '../styled';
import { ParametrsModalProps } from '../types';

const ParametrsModal = ({
  closeModal,
  open,
  children,
}: ParametrsModalProps) => {
  return (
    <CustomDrawer
      open={open}
      anchor="bottom"
      onClose={closeModal}
      disableRestoreFocus
      closeAfterTransition
      disableEscapeKeyDown
    >
      {children}
    </CustomDrawer>
  );
};

export default ParametrsModal;
